export default __webpack_public_path__ + "static/SR_India_-_ISO_50001-_Certificate.pdf-cfc0c1414d563f6b0eb2b6f3214c5702.pdf";